module.exports = __webpack_public_path__ + "static/img/run-running.7fd12d1f.png";